import RouteEventViewModel from 'visuris/ViewModels/Route/RouteEventViewModel';
import { formatDateShortenToday } from 'visuris/Data/Formatters';
import { VoyageResultHelper } from '../../Helpers/VoyageResultHelper';

export default class RouteDirectionViewModel {
    public text: string;
    public maneuverType: string;
    public time: number;
    public eta: Date;
    public events: RouteEventViewModel[];
    public feature: any;
    public isrs: string;
    public compressedGeometry: any;
    public urlToDetail: string;
    public totalLength: string;
    public countryCodes: string[];
    
    public hasUrl(): boolean {
        return this.urlToDetail != null;
    }

    public hasETA(): boolean {
        return this.eta != null;
    }

    public formattedETA(): string {
        return formatDateShortenToday(this.eta);
    }

    public formattedTotalLength(): string {
        if (this.totalLength == null || this.totalLength == '') {
            return '';
        }

        if (this.hasETA()) {
            return ' ' + this.totalLength;
        }
        return this.totalLength;
    }

    public isCommonBorder(): boolean {
        return this.countryCodes != null && this.countryCodes.length > 1;
    }

    public getCommonBorderColor(): string {
        this.countryCodes.sort();
        return VoyageResultHelper.getColorFromString(this.countryCodes.join(''));
    }

    public getCommonBorderFlags(): string[] {
        this.countryCodes.sort();
        const results: string[] = [];
        for (let cc of this.countryCodes) {
            results.push('a-icon-country-' + cc.toLowerCase());
        }
        return results;
    }
}